<template>
  <app-section theme="nude">
    <h3>{{ t("ERROR 404 Not Found:") }}</h3>
    <p>
      {{ t("We were unable to find the file you were looking for:") }} {{ fullUrl }}
      {{ t("If you really, really want to see that page, please leave me a notice at technikfee@ersties.com.") }}
    </p>
    <p>{{ t("In the mean time, please enjoy the rest of our exciting website.") }}</p>
  </app-section>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import AppSection from "@/components/v2/section/index.vue";
import { useI18n } from "vue-i18n";

defineOptions({
  name: "not-found-v2",
});

const route = useRoute();
const { t } = useI18n();

const fullUrl = window.location.host + route.fullPath;
</script>
